import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

// Get the root element safely
const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found! Make sure your HTML has a <div id='root'></div>");
}

const root = ReactDOM.createRoot(rootElement);

// Render App without StrictMode in production
root.render(
  process.env.NODE_ENV === "development" ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (
    <App />
  )
);
